import { takeEveryApiCall } from 'syft-acp-core/sagas/helpers'

import csatEmployersTypes from './action-types'
import { fetchCsatEmployerList } from './api'

export default function* root() {
  yield takeEveryApiCall(csatEmployersTypes.ENTITIES_FETCH_BEGIN, fetchCsatEmployerList)
}
